module.exports = __webpack_public_path__ + "img/scancode3.f53716af.png";